module.exports = __webpack_public_path__ + "static/media/bg.0c1fb62f.svg";